<button (click)="onClose()">
    <div class="flex flex-row gap-2 overflow-wrap bg-red-700 hover:bg-red-600 text-white p-1 rounded card-shadow w-96 items-start text-xs sm:text-sm scale-up-center">
        <div class="grow overflow-wrap break-all">{{ message }}</div>
        <svg-icon [svgIcon]="svgIcon" [small]="true" class="fill-none stroke-white"></svg-icon>
    </div>
</button>